import React, { Component } from 'react';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
// use font awesome
import { loadCSS } from 'fg-loadcss/src/loadCSS';
// import "font-awesome/css/font-awesome.css";
import Icon from '@material-ui/core/Icon';
// use font awesome
import { withStyles } from '@material-ui/core/styles';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import strings from './language/language';

const styles = (theme) => ({
  main: {
    backgroundColor: '#f2f2f2',
    padding: '40px 120px 20px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 15px 20px',
    },
  },
  backButton: {
    color: '#fff',
    '&:hover': {
      backgroundColor: '#998d9059',
    },
  },
  mainTitle: {
    textAlign: 'center',
    color: '#000',
    paddingBottom: 15,
    fontSize: 40,
    '&::after': {
      content: "''",
      display: 'block',
      width: 65,
      height: 2,
      margin: '25px auto',
      backgroundColor: '#70142c',
    },
  },
  mainTitle1: {
    color: '#70142c',
  },
  socials: {
    textAlign: 'center',
    backgroundColor: '#70142c',
    color: '#fff',
    padding: '30px 15px',
  },
  mainContainer: {
    padding: '0 15px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    margin: 5,
    border: '1px solid',
    borderRadius: theme.shape.borderRadius * 9,
    padding: 10,
    cursor: 'pointer',
    transition: 'all .3s ease-in-out',
  },
  facebook: {
    '&:hover': {
      backgroundColor: '#3b5998',
      border: '1px solid #3b5998',
    },
  },
  twitter: {
    '&:hover': {
      backgroundColor: '#1da1f2',
      border: '1px solid #1da1f2',
    },
  },
  instagram: {
    '&:hover': {
      backgroundColor: '#e1306c',
      border: '1px solid #e1306c',
    },
  },
  info: {
    padding: '30px 20px',
  },
  infoIcon: {
    marginRight: 5,
    verticalAlign: 'bottom',
    color: '#70142c',
  },
  links: {
    color: '#fff',
    textDecoration: 'none',
  },
  phone: {
    marginBottom: 20,
  },
  map: {
    position: 'relative !important',
    height: '315px !important',
    border: '1px solid #C1C1C1',
  },
  address: {
    width: '100%',
    marginBottom: 20,
  },
  addressInfo: {
    padding: '30px 25px',
    margin: '0 15px',
  },
  addressTitle: {
    marginBottom: 20,
  },
  addressDesc: {
    lineHeight: 1.5,
    wordBreak: 'break-all',
  },
});

class Footer extends Component {
  componentDidMount() {
    loadCSS(
      'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
      document.querySelector('#insertion-point-jss')
    );
  }
  render() {
    const { classes, info, color } = this.props;
    return (
      // <Hidden smDown>
      <div>
        <div id='add-item-header' style={{ backgroundColor: color }}>
          <NavLink to='/order' style={{ textDecoration: 'none' }}>
            <Button className={classes.backButton}>
              <ArrowLeft /> {strings.back}
            </Button>
          </NavLink>
        </div>
        <div className={classes.main}>
          <Typography
            variant='display1'
            component='h1'
            className={classes.mainTitle}
          >
            {strings.contact}{' '}
            <span className={classes.mainTitle1} style={{ color: color }}>
              {strings.us}
            </span>
          </Typography>
          <Grid
            container
            spacing={32}
            id='about-us'
            className={classes.mainContainer}
          >
            <Grid item md={8} sm={12} xs={12}>
              <Map
                google={this.props.google}
                initialCenter={{
                  lat: parseFloat(info.latitude),
                  lng: parseFloat(info.longitude),
                }}
                className={classes.map}
                zoom={14}
              >
                <Marker
                  onClick={this.onMarkerClick}
                  name={'Current location'}
                />

                <InfoWindow onClose={this.onInfoWindowClose} />
              </Map>
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <div className={classes.contact}>
                <Paper
                  className={classes.socials}
                  style={{ backgroundColor: color }}
                >
                  <Typography
                    variant='h4'
                    component='h4'
                    gutterBottom
                    className={classes.title}
                  >
                    {strings.follow_us}
                  </Typography>
                  <div className={classes.social}>
                    {info.facebook && (
                      <a href={info.facebook} className={classes.links}>
                        <Icon
                          className={classNames(
                            classes.icon,
                            classes.facebook,
                            'fab fa-facebook-f'
                          )}
                        />
                      </a>
                    )}
                    {info.instagram && (
                      <a href={info.instagram} className={classes.links}>
                        <Icon
                          className={classNames(
                            classes.icon,
                            classes.twitter,
                            'fab fa-twitter'
                          )}
                        />
                      </a>
                    )}
                    {info.twitter && (
                      <a href={info.twitter} className={classes.links}>
                        <Icon
                          className={classNames(
                            classes.icon,
                            classes.instagram,
                            'fab fa-instagram'
                          )}
                        />
                      </a>
                    )}
                  </div>
                </Paper>
                <Paper
                  className={classes.info}
                  style={{
                    textAlign:
                      (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                        ? 'right'
                        : 'left',
                  }}
                >
                  <Typography
                    variant='h4'
                    component='h4'
                    gutterBottom
                    className={classes.title}
                  >
                    {strings.contact_us}
                  </Typography>
                  <div className={classes.phone}>
                    <Icon
                      className={classNames(
                        classes.infoIcon,
                        'fas fa-phone-square'
                      )}
                      style={{ color: color }}
                    />{' '}
                    <span>{info.phone}</span>
                  </div>
                  <div>
                    <Icon
                      className={classNames(
                        classes.infoIcon,
                        'fas fa-envelope'
                      )}
                      style={{ color: color }}
                    />{' '}
                    <span style={{ fontFamily: 'roboto' }}>{info.email}</span>
                  </div>
                </Paper>
              </div>
            </Grid>
            <div
              className={classes.address}
              style={{
                textAlign:
                  (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                    ? 'right'
                    : 'left',
              }}
            >
              <Paper className={classes.addressInfo}>
                <Typography
                  variant='h2'
                  component='h2'
                  gutterBottom
                  className={classes.addressTitle}
                >
                  {strings.address}
                </Typography>
                <Typography
                  variant='h5'
                  component='p'
                  className={classes.addressDesc}
                >
                  {' '}
                  {info.address}
                </Typography>
              </Paper>
            </div>
          </Grid>
        </div>
      </div>
      //</Hidden>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyA-Mz7gBEjuOE1hWQhr_RenPhVhE9hqYq8',
})(withStyles(styles)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js